import PCSpec from './PCSpec'

export default PCSpec;